/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SiteMapList } from './SiteMapList';
import {
    SiteMapListFromJSON,
    SiteMapListFromJSONTyped,
    SiteMapListToJSON,
    SiteMapListToJSONTyped,
} from './SiteMapList';

/**
 * 
 * @export
 * @interface PaginatedSiteMapListList
 */
export interface PaginatedSiteMapListList {
    /**
     * 
     * @type {string}
     * @memberof PaginatedSiteMapListList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedSiteMapListList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<SiteMapList>}
     * @memberof PaginatedSiteMapListList
     */
    results: Array<SiteMapList>;
}

/**
 * Check if a given object implements the PaginatedSiteMapListList interface.
 */
export function instanceOfPaginatedSiteMapListList(value: object): value is PaginatedSiteMapListList {
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedSiteMapListListFromJSON(json: any): PaginatedSiteMapListList {
    return PaginatedSiteMapListListFromJSONTyped(json, false);
}

export function PaginatedSiteMapListListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedSiteMapListList {
    if (json == null) {
        return json;
    }
    return {
        
        'next': json['next'] === undefined ? undefined : json['next'] === null ? null : json['next'],
        'previous': json['previous'] === undefined ? undefined : json['previous'] === null ? null : json['previous'],
        'results': ((json['results'] as Array<any>).map(SiteMapListFromJSON)),
    };
}

export function PaginatedSiteMapListListToJSON(json: any): PaginatedSiteMapListList {
    return PaginatedSiteMapListListToJSONTyped(json, false);
}

export function PaginatedSiteMapListListToJSONTyped(value?: PaginatedSiteMapListList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(SiteMapListToJSON)),
    };
}

